<template>
    <el-tooltip 
    effect="dark" 
    content="点击展开/关闭登录账号全称" 
    placement="bottom"
    >
        <span 
        class="btn-eye sysfont"
        @click.stop="toggleHandler"
        v-html="model ? '&#xe60c;' : '&#xe613;'"
        ></span>
    </el-tooltip>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
    methods: {
        toggleHandler() {
            this.model = !this.model;
        },
    },
};
</script>